import React from 'react'
import Button from '../../../../../../../Components/Buttons/Button'
import Calendar from '../../../../../../../Modules/Calendar/Calendar'

const EnrollmentCalendar = ({
  toggleModal,
  initiateEnrollmentRequest,
  getPickedSlots,
  livDemyID,
  noOfClasses,
  name,
}) => {
  return (
    <div className='enrollmentCalendar'>
      <Button
        onClick={async () =>
          toggleModal(await initiateEnrollmentRequest(getPickedSlots()))
        }
        name={'Request Enrollment'}
        type={'primary big'}
      />
      <Calendar
        livDemyID={livDemyID}
        slots={noOfClasses}
        courseInfo={{ name: name }}
      />
    </div>
  )
}

export default EnrollmentCalendar
